import { useGetTargetSide } from '_api';

const useTargetSide = () => {
  const { data: targetSideOptions, isFetching: isLoading } = useGetTargetSide();

  return { targetSideOptions, isLoading };
};

export default useTargetSide;
